var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.812 7.548a2.493 2.493 0 0 1 .091 1.644l5.243 3.206a2.5 2.5 0 1 1-.732.724l-4.976-3.043a2.5 2.5 0 1 1-.184-3.36l4.984-3.154a2.5 2.5 0 1 1 .6.802L4.812 7.549Z"
  })));
};
export default SvgShareIcon;